import React, { useState, useEffect } from "react";
import api from "../services/api";

const CrearRequisicion = () => {
  // ✅ Estados para categorías
  const [materiales, setMateriales] = useState([]);
  const [materialesOriginal, setMaterialesOriginal] = useState([]); // 👈 Backup sin filtrar
  const [categorias, setCategorias] = useState([]);
  const [categoriaFiltro, setCategoriaFiltro] = useState(""); // 👈 ID de categoría seleccionada
  
  // ✅ NUEVO: Estados para proyectos
  const [config, setConfig] = useState(null);
  const [proyectos, setProyectos] = useState([]);
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState("");
  
  const [carritoItems, setCarritoItems] = useState([]);
  const [formData, setFormData] = useState({
    observaciones: "",
  });
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });
  const [loading, setLoading] = useState(false);
  const [usuario, setUsuario] = useState(null);

  // Item temporal para agregar al carrito
  const [itemTemp, setItemTemp] = useState({
    material_id: "",
    cantidad: "",
    observacion: "",
  });

  // ✅ MODIFICADO: Cargar materiales, categorías, configuración y usuario
  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const payload = JSON.parse(atob(token.split(".")[1]));
          setUsuario(payload);
        }

        // 👇 Cargar materiales, categorías Y configuración en paralelo
        const [resMateriales, resCategorias, resConfig] = await Promise.all([
          api.get("/materiales"),
          api.get("/categorias"),
          api.get("/configuracion"), // 👈 NUEVO
        ]);

        setMateriales(resMateriales.data);
        setMaterialesOriginal(resMateriales.data);
        setCategorias(resCategorias.data);
        setConfig(resConfig.data); // 👈 NUEVO
      } catch (error) {
        console.error("Error cargando datos:", error);
        setMensaje({ texto: "❌ Error al cargar materiales y categorías", tipo: "error" });
      }
    };
    cargarDatos();
  }, []);

  // ✅ NUEVO: Cargar proyectos SOLO si el módulo está activo
  useEffect(() => {
    if (config?.modulo_proyectos) {
      const cargarProyectos = async () => {
        try {
          const res = await api.get("/proyectos/activos"); // Solo proyectos activos
          setProyectos(res.data);
        } catch (error) {
          console.error("Error cargando proyectos:", error);
          // No mostramos error al usuario, simplemente no habrá proyectos disponibles
        }
      };
      cargarProyectos();
    }
  }, [config]);

  // ✅ NUEVO: Función para filtrar materiales por categoría
  const filtrarPorCategoria = (catId) => {
    setCategoriaFiltro(catId);
    if (catId) {
      const materialesFiltrados = materialesOriginal.filter(
        (m) => m.CategoriaId === parseInt(catId)
      );
      setMateriales(materialesFiltrados);
    } else {
      setMateriales(materialesOriginal); // Mostrar todos
    }
    // 👇 Resetear material seleccionado al cambiar categoría
    setItemTemp({ material_id: "", cantidad: "", observacion: "" });
  };

  // Agregar item al carrito
  const agregarAlCarrito = () => {
    if (!itemTemp.material_id || !itemTemp.cantidad || parseFloat(itemTemp.cantidad) <= 0) {
      setMensaje({ texto: "⚠️ Seleccione un material y cantidad válida", tipo: "error" });
      return;
    }

    const material = materiales.find(m => m.id === parseInt(itemTemp.material_id));
    
    if (!material) {
      setMensaje({ texto: "❌ Material no encontrado", tipo: "error" });
      return;
    }

    if (material.stock_actual < parseFloat(itemTemp.cantidad)) {
      setMensaje({ 
        texto: `⚠️ Stock insuficiente. Disponible: ${material.stock_actual} ${material.unidad || 'unidades'}`, 
        tipo: "error" 
      });
      return;
    }

    const nuevoItem = {
      material_id: material.id,
      codigo: material.codigo,
      nombre: material.nombre,
      cantidad: parseFloat(itemTemp.cantidad),
      observacion: itemTemp.observacion,
      unidad: material.unidad || 'unidad',
      stock_disponible: material.stock_actual,
    };

    setCarritoItems([...carritoItems, nuevoItem]);
    setItemTemp({ material_id: "", cantidad: "", observacion: "" });
    setMensaje({ texto: "", tipo: "" });
  };

  // Quitar item del carrito
  const quitarDelCarrito = (index) => {
    setCarritoItems(carritoItems.filter((_, i) => i !== index));
  };

  // Enviar requisición
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (carritoItems.length === 0) {
      setMensaje({ texto: "⚠️ Agregue al menos un material a la requisición", tipo: "error" });
      return;
    }

    // ✅ NUEVO: Validar proyecto si el módulo está activo
    if (config?.modulo_proyectos && proyectos.length > 0 && !proyectoSeleccionado) {
      setMensaje({ texto: "⚠️ Debe seleccionar un proyecto para esta requisición", tipo: "error" });
      return;
    }

    try {
      setLoading(true);

      const payload = {
       observaciones: formData.observaciones,
       departamento: usuario?.departamento || 'Sin departamento',
       proyecto_id: proyectoSeleccionado || null, // 👈 NUEVO: Incluir proyecto si existe
       materiales: carritoItems.map(item => ({
        material_id: item.material_id,
           cantidad: item.cantidad,
         observacion: item.observacion,
  })),
};


      const response = await api.post("/requisiciones/crear", payload);

      setMensaje({
        texto: "✅ Requisición creada correctamente. El almacenero la procesará pronto.",
        tipo: "success",
      });

      setFormData({ observaciones: "" });
      setCarritoItems([]);
      setCategoriaFiltro(""); // Resetear filtro de categoría
      setProyectoSeleccionado(""); // 👈 NUEVO: Resetear proyecto
      setMateriales(materialesOriginal); // Restaurar todos los materiales
      
      setTimeout(() => setMensaje({ texto: "", tipo: "" }), 5000);
    } catch (error) {
      console.error("Error al crear requisición:", error);
      setMensaje({
        texto: "❌ " + (error.response?.data?.mensaje || "Error al crear la requisición"),
        tipo: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const getMaterialSeleccionado = () => {
    return materiales.find(m => m.id === parseInt(itemTemp.material_id));
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>📝 Crear Requisición de Material</h1>
        <p style={styles.subtitle}>Solicitud de materiales para tu departamento</p>
      </div>

      {/* Mensaje */}
      {mensaje.texto && (
        <div style={{
          ...styles.message,
          ...(mensaje.tipo === "success" ? styles.messageSuccess : styles.messageError)
        }}>
          {mensaje.texto}
        </div>
      )}

      {/* Información del flujo */}
      <div style={styles.infoCard}>
        <h3 style={styles.infoTitle}>📋 Flujo de la requisición:</h3>
        <div style={styles.flowSteps}>
          <div style={styles.flowStep}>
            <span style={styles.flowNumber}>1️⃣</span>
            <span style={styles.flowText}>Tú creas la requisición</span>
          </div>
          <div style={styles.flowArrow}>→</div>
          <div style={styles.flowStep}>
            <span style={styles.flowNumber}>2️⃣</span>
            <span style={styles.flowText}>Almacenero procesa</span>
          </div>
          <div style={styles.flowArrow}>→</div>
          <div style={styles.flowStep}>
            <span style={styles.flowNumber}>3️⃣</span>
            <span style={styles.flowText}>Supervisor aprueba</span>
          </div>
          <div style={styles.flowArrow}>→</div>
          <div style={styles.flowStep}>
            <span style={styles.flowNumber}>4️⃣</span>
            <span style={styles.flowText}>Almacenero entrega</span>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Información General */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>📋 Información General</h3>
          
          {/* Mostrar departamento del usuario */}
          {usuario?.departamento && (
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Departamento:</span>
              <span style={styles.infoValue}>{usuario.departamento}</span>
            </div>
          )}

          <div style={styles.formGroup}>
            <label style={styles.label}>Observaciones Generales</label>
            <textarea
              style={styles.textarea}
              rows={3}
              placeholder="Motivo de la requisición, proyecto, urgencia, etc."
              value={formData.observaciones}
              onChange={(e) => setFormData({...formData, observaciones: e.target.value})}
            />
          </div>

          {/* ✅ NUEVO: Selector de Proyecto (solo si el módulo está activo) */}
          {config?.modulo_proyectos && proyectos.length > 0 && (
            <div style={styles.formGroup}>
              <label style={styles.label}>
                <span style={styles.labelIcon}>🏗️</span>
                Proyecto <span style={styles.required}>*</span>
              </label>
              <select
                style={styles.select}
                value={proyectoSeleccionado}
                onChange={(e) => setProyectoSeleccionado(e.target.value)}
              >
                <option value="">-- Seleccione un proyecto --</option>
                {proyectos.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.nombre} {p.ubicacion ? `(${p.ubicacion})` : ''}
                  </option>
                ))}
              </select>
              {proyectoSeleccionado && (
                <div style={styles.proyectoInfo}>
                  {proyectos.find(p => p.id === parseInt(proyectoSeleccionado))?.responsable && (
                    <span style={{fontSize: '12px', color: '#64748b'}}>
                      👤 Responsable: {proyectos.find(p => p.id === parseInt(proyectoSeleccionado))?.responsable}
                    </span>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Agregar Materiales */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>📦 Agregar Materiales</h3>
          
          {/* ✅ NUEVO: Filtro de Categoría */}
          <div style={styles.formGroup}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>📂</span>
              Filtrar por Categoría
            </label>
            <select
              style={styles.select}
              value={categoriaFiltro}
              onChange={(e) => filtrarPorCategoria(e.target.value)}
            >
              <option value="">📋 Todas las categorías</option>
              {categorias.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.nombre}
                </option>
              ))}
            </select>
          </div>

          <div style={styles.formGrid}>
            <div style={styles.formGroup}>
              <label style={styles.label}>
                Material <span style={styles.required}>*</span>
              </label>
              <select
                style={styles.select}
                value={itemTemp.material_id}
                onChange={(e) => setItemTemp({...itemTemp, material_id: e.target.value})}
              >
                <option value="">-- Seleccione un material --</option>
                {materiales.map((mat) => (
                  <option key={mat.id} value={mat.id}>
                    {mat.codigo} - {mat.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>
                Cantidad <span style={styles.required}>*</span>
              </label>
             <input
  type="number"
  step="1"
  min="1"
  style={styles.input}
  placeholder="Ej: 50"
  value={itemTemp.cantidad}
  onChange={(e) =>
    setItemTemp({
      ...itemTemp,
      cantidad: parseInt(e.target.value, 10) || "",
    })
  }
/>

            </div>
          </div>

          {/* Info del material seleccionado */}
          {getMaterialSeleccionado() && (
            <div style={styles.materialInfo}>
              <div style={styles.materialInfoRow}>
                <span style={styles.materialInfoLabel}>Stock disponible:</span>
                <span style={styles.materialInfoValue}>
                  {getMaterialSeleccionado().stock_actual} {getMaterialSeleccionado().unidad || 'unidades'}
                </span>
              </div>
              {getMaterialSeleccionado().ubicacion && (
                <div style={styles.materialInfoRow}>
                  <span style={styles.materialInfoLabel}>Ubicación:</span>
                  <span style={styles.materialInfoValue}>
                    {getMaterialSeleccionado().ubicacion}
                  </span>
                </div>
              )}
            </div>
          )}

          <div style={styles.formGroup}>
            <label style={styles.label}>Observación del ítem</label>
            <input
              type="text"
              style={styles.input}
              placeholder="Observación específica para este material (opcional)"
              value={itemTemp.observacion}
              onChange={(e) => setItemTemp({...itemTemp, observacion: e.target.value})}
            />
          </div>

          <button
            type="button"
            style={styles.btnAdd}
            onClick={agregarAlCarrito}
          >
            ➕ Agregar al Carrito
          </button>
        </div>

        {/* Carrito de Materiales */}
        {carritoItems.length > 0 && (
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>🛒 Carrito ({carritoItems.length} materiales)</h3>
            
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHeaderRow}>
                    <th style={{...styles.th, width: '10%'}}>Código</th>
                    <th style={{...styles.th, width: '25%'}}>Material</th>
                    <th style={{...styles.th, width: '12%', textAlign: 'center'}}>Cantidad</th>
                    <th style={{...styles.th, width: '15%', textAlign: 'center'}}>Stock Disponible</th>
                    <th style={{...styles.th, width: '23%'}}>Observación</th>
                    <th style={{...styles.th, width: '15%', textAlign: 'center'}}>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {carritoItems.map((item, index) => (
                    <tr 
                      key={index} 
                      style={styles.tr}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                    >
                      <td style={styles.td}>{item.codigo}</td>
                      <td style={styles.td}>{item.nombre}</td>
                      <td style={styles.tdNum}>{item.cantidad} {item.unidad}</td>
                      <td style={styles.tdNum}>{item.stock_disponible} {item.unidad}</td>
                      <td style={styles.td}>{item.observacion || '-'}</td>
                      <td style={{...styles.td, textAlign: 'center'}}>
                        <button
                          type="button"
                          style={styles.btnDelete}
                          onClick={() => quitarDelCarrito(index)}
                        >
                          🗑️ Quitar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Botón Enviar */}
        <div style={styles.actions}>
          <button
            type="submit"
            style={{...styles.btnSubmit, opacity: loading ? 0.6 : 1}}
            disabled={loading || carritoItems.length === 0}
          >
            {loading ? "Enviando..." : "📤 Enviar Requisición"}
          </button>
        </div>
      </form>

      {/* Ayuda */}
      <div style={styles.helpCard}>
        <p style={styles.helpText}>
          💡 <strong>Tip:</strong> Puedes agregar múltiples materiales a una sola requisición. 
          Verifica que haya stock disponible antes de solicitar.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8fafc',
    padding: '20px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    marginBottom: '25px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 5px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: '0',
  },
  message: {
    marginBottom: '20px',
    padding: '12px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',
  },
  messageSuccess: {
    background: '#d1fae5',
    color: '#065f46',
    border: '1px solid #10b981',
  },
  messageError: {
    background: '#fee2e2',
    color: '#991b1b',
    border: '1px solid #ef4444',
  },
  infoCard: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '25px',
    color: 'white',
  },
  infoTitle: {
    fontSize: '16px',
    fontWeight: '600',
    margin: '0 0 15px 0',
  },
  flowSteps: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '10px',
  },
  flowStep: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
    flex: '1',
    minWidth: '120px',
  },
  flowNumber: {
    fontSize: '24px',
  },
  flowText: {
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: '500',
  },
  flowArrow: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    marginBottom: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 20px 0',
  },
  formGroup: {
    marginBottom: '20px',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginBottom: '20px',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '6px',
  },
  labelIcon: {
    fontSize: '16px',
  },
  required: {
    color: '#ef4444',
    fontWeight: 'bold',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box',
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    background: 'white',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  materialInfo: {
    background: '#f8fafc',
    borderRadius: '8px',
    padding: '15px',
    marginBottom: '15px',
  },
  materialInfoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 0',
  },
  materialInfoLabel: {
    fontSize: '13px',
    color: '#64748b',
    fontWeight: '600',
  },
  materialInfoValue: {
    fontSize: '13px',
    color: '#1e293b',
    fontWeight: '600',
  },
  btnAdd: {
    padding: '10px 20px',
    background: '#10b981',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  tableContainer: {
    overflowX: 'auto',
    marginBottom: '15px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  tableHeaderRow: {
    background: '#1e293b',
    color: 'white',
  },
  th: {
    padding: '14px 12px',
    textAlign: 'left',
    fontWeight: '600',
    borderBottom: '2px solid #cbd5e1',
    whiteSpace: 'nowrap',
  },
  tr: {
    borderBottom: '1px solid #e2e8f0',
    transition: 'background 0.2s ease',
  },
  td: {
    padding: '12px',
    color: '#475569',
    verticalAlign: 'middle',
  },
  tdNum: {
    padding: '12px',
    color: '#1e293b',
    textAlign: 'center',
    fontWeight: '600',
  },
  btnDelete: {
    padding: '6px 12px',
    background: '#ef4444',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '14px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  btnSubmit: {
    padding: '14px 40px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
  },
  helpCard: {
    background: '#eff6ff',
    border: '1px solid #3b82f6',
    borderRadius: '12px',
    padding: '15px 20px',
  },
  helpText: {
    margin: '0',
    fontSize: '13px',
    color: '#1e40af',
    lineHeight: '1.6',
  },
  // Estilos nuevos para mostrar el departamento
  infoRow: {
    display: 'flex',
    gap: '10px',
    padding: '10px 0',
    fontSize: '14px',
    color: '#475569',
  },
  infoLabel: {
    fontWeight: '600',
    color: '#1e293b',
  },
  infoValue: {
    color: '#1e293b',
  },
  // ✅ NUEVO: Estilo para info de proyecto
  proyectoInfo: {
    marginTop: '8px',
    padding: '8px 12px',
    background: '#f0f9ff',
    borderRadius: '6px',
    borderLeft: '3px solid #3b82f6',
  },
};

export default CrearRequisicion;